// extracted by mini-css-extract-plugin
module.exports = {"Back":"Game_Back__3kMhw","Main":"Game_Main__3JOKJ","Loading":"Game_Loading__3g_lt"};